import * as dat from "lil-gui";

export default class GUI {
  constructor() {
    this.dat = new dat.GUI();
    this.dat.hide();
  }
}
